import { reportClientError } from "#ce/utils/error-report";

/**
 * Sends a failed `Sparkle.ready` snippet through the app's client error reporter (`reportClientError`).
 *
 * @param {Error} error - what the snippet threw; its stack is not sent, since frames name the document URL
 * @param {String} [origin] - template path that queued the snippet
 */
export function reportBootError(error, origin) {
  reportClientError("Sparkle.ready snippet failed", {
    description: [origin, error instanceof Error ? `${error.name}: ${error.message}` : String(error)]
      .filter(Boolean)
      .join(" — "),
    baseUrl: import.meta.url,
    omitPage: true,
  });
}
